import { useState } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import {
  Button,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
} from '@mui/material';
import { Add, DeleteOutlined } from '@mui/icons-material';
import { EmptyState } from '@/components';
import InputText from '@/components/InputText';
import { Content } from '@/types';
import * as Yup from 'yup';

export const reqElements = Yup.string()
  .required('Necesitas llenar este campo')
  .min(3, 'El ingrediente debe tener un mínimo de 3 caracteres');

interface InputProps {
  value: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const Input = ({ value, onBlur }: InputProps) => {
  const [inputValue, setInputValue] = useState(value);

  const handleChange = (e: { target: { value: string } }) => {
    setInputValue(e.target.value);
  };

  return (
    <TextField
      value={inputValue}
      onChange={handleChange}
      onBlur={onBlur}
      fullWidth={true}
      sx={{ backgroundColor: 'white' }}
    />
  );
};

const Elements = () => {
  const { values, errors, touched } = useFormikContext<Content>();

  return (
    <Paper
      elevation={2}
      sx={{
        padding: 2,
        borderRadius: 2,
      }}
    >
      <Stack spacing={2}>
        <FieldArray
          name="elements"
          render={(arrayHelpers) => (
            <Stack gap={2}>
              {(values?.elements ?? []).map((_, index) => (
                <div key={`ingredient-${index}`}>
                  <InputText
                    label={`Ingrediente`}
                    name={`elements[${index}]`}
                    value={values.elements[index]}
                    error={Boolean(
                      errors?.elements?.[index] && touched?.elements?.[index]
                    )}
                    helperText={
                      errors?.elements?.[index] && touched?.elements?.[index]
                        ? errors?.elements?.[index]
                        : ''
                    }
                    slotProps={{
                      input: {
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => arrayHelpers.remove(index)}
                            >
                              <DeleteOutlined />
                            </IconButton>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </div>
              ))}

              {values?.elements?.length ? (
                <Stack direction="row" justifyContent="center">
                  <Button
                    variant="outlined"
                    size="medium"
                    fullWidth={false}
                    onClick={() => arrayHelpers.push('')}
                    startIcon={<Add />}
                  >
                    Agregar Elemento
                  </Button>
                </Stack>
              ) : (
                <Stack spacing={2} padding={'32px 16px'}>
                  <EmptyState
                    action={{
                      onClick: () => arrayHelpers.push(''),
                      startIcon: <Add />,
                      children: 'Agregar Elemento',
                      variant: 'outlined',
                    }}
                  />
                </Stack>
              )}
            </Stack>
          )}
        />
      </Stack>
    </Paper>
  );
};

export default Elements;
